import React from 'react';

const IconArrowDown: React.FC = () => (
  <svg 
    fill="none"
    width="24"
    height="24"
    style={{ marginBottom: '-4px' }}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 5V19"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19 12L12 19L5 12"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default IconArrowDown;